import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { userEffectiveNameWarOptions, userEffectiveNameOptions, userEffectiveCpfOptions } = useReportFiltersFetch({fetchEffectiveNameWar: true, fetchEffectiveName: true, fetchEffectiveCpf: true});

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data de início *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data de conclusão *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputForm
                        label="Nome do curso"
                        value={filters.course}
                        onChange={({target}) => setFilters(prev => ({ ...prev, course: target.value }))}
                        instanceId="courseName"
                        id="courseName"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <AccessForm
                        filters={filters}
                        setFilters={setFilters}
                        customTitle={'Agente'}
                        hasLoginInput={false}
                        hasNameWarInput={true}
                        customUserNameWarOptions={userEffectiveNameWarOptions}
                        customUserNameOptions={userEffectiveNameOptions}
                        customUserCpfOptions={userEffectiveCpfOptions}
                    />

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="searchDetails"
                            label="Exibir detalhes"
                            checked={filters.searchDetails}
                            onChange={(e) => setFilters(prev => ({...prev, searchDetails: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;